import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import {
  analyzeProspect, updateStatus, updateProspect, deleteProspect, startSequence, completeStep,
  addContactLog, generateMessages, fetchProspectInstagram, runEngine, generateActionPlan,
} from "../../lib/api";

const detail = (e, fallback) => e?.response?.data?.detail || fallback;

export function useProspectActions(prospect, { onChanged, onOpenChange, onDeleted }) {
  const [p, setP] = useState(prospect);
  const [busy, setBusy] = useState({});

  useEffect(() => { setP(prospect); }, [prospect]);

  const apply = useCallback((res) => { setP(res); onChanged && onChanged(res); }, [onChanged]);

  const run = useCallback(async (key, fn, { ok, err }) => {
    setBusy((b) => ({ ...b, [key]: true }));
    try {
      const res = await fn();
      if (res) apply(res);
      if (ok) toast.success(typeof ok === "function" ? ok(res) : ok);
      return res;
    } catch (e) {
      toast.error(detail(e, err));
      return null;
    } finally {
      setBusy((b) => ({ ...b, [key]: false }));
    }
  }, [apply]);

  return {
    p, busy, apply,
    analyze: () => run("analyze", () => analyzeProspect(p.id), { ok: "Analisi AI completata 🔥", err: "Analisi AI fallita, riprova" }),
    changeStatus: (status) => run("status", () => updateStatus(p.id, status), { ok: "Stato aggiornato", err: "Errore aggiornamento stato" }),
    saveQualification: (q) => run("qual", () => updateProspect(p.id, { ...p, qualification: q, ai_analyzed: p.ai_analyzed }), { ok: "Qualificazione salvata", err: "Salvataggio fallito" }),
    remove: async () => {
      try {
        await deleteProspect(p.id);
        toast.success("Prospect eliminato");
        onOpenChange(false);
        onDeleted && onDeleted(p.id);
      } catch (e) { toast.error(detail(e, "Eliminazione fallita")); }
    },
    startSequence: () => run("seq", () => startSequence(p.id), { ok: "Sequenza contatti avviata (D1/D3/D5/D8/D15)", err: "Avvio sequenza fallito" }),
    completeStep: (idx, form) => run("step", () => completeStep(p.id, idx, form), { ok: "Step completato e registrato", err: "Registrazione fallita" }),
    addLog: (form) => run("log", () => addContactLog(p.id, form), { ok: "Tentativo registrato", err: "Registrazione fallita" }),
    generateMessages: () => run("msg", async () => ({ ...p, messages: await generateMessages(p.id) }), { ok: "Messaggi generati ✍️", err: "Generazione messaggi fallita" }),
    fetchInstagram: () => run("ig", () => fetchProspectInstagram(p.id), { ok: (r) => `Dati Instagram aggiornati da @${r.ig_stats?.username || p.instagram}`, err: "Fetch Instagram fallito" }),
    runEngine: () => {
      toast.info("Motore avviato: sito, Instagram, AI e piano d'azione...");
      return run("engine", () => runEngine(p.id), { ok: (r) => `Analisi completa: ${r.acquisition?.probability}% di acquisizione`, err: "Analisi completa fallita" });
    },
    regenPlan: () => run("plan", () => generateActionPlan(p.id), { ok: "Piano d'azione generato", err: "Generazione piano fallita" }),
  };
}
